import type {
  BlockStateDefinition,
  ImplicitDependencyGroup,
} from '@unifyapps/carbon/no-code/components/BlockDefinition';
import type {
  BlockStateUnionType,
  BlockType,
  ComponentTypeUnionType,
} from '@unifyapps/defs/types/block';
import _pick from 'lodash/pick';
import { lazy } from 'react';

const importStatCardComponent = () =>
  import(
    /* webpackChunkName: "stat-card-block" */
    './StatCard'
  );

const StatCard = lazy(importStatCardComponent);

class StatCardBlockStateDefinition implements BlockStateDefinition {
  getComponent() {
    return StatCard;
  }

  get type(): ComponentTypeUnionType {
    return 'StatCard';
  }

  get initialStateGetter() {
    return (block: BlockType) =>
      ({
        id: block.id,
        ..._pick(block.component, ['content', 'appearance', 'componentType']),
      }) as BlockStateUnionType;
  }

  preload() {
    return {
      blockPreload: importStatCardComponent,
    };
  }

  getImplicitDependencyGroups(): ImplicitDependencyGroup {
    return { isEntitySuspended: true, usingUserContext: true };
  }
}

export default StatCardBlockStateDefinition;
